<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="categories"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="internal_name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <h5>
                          {{ $t("category.internal_name") }}
                        </h5>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-text-field
                            v-model="editedItem.internal_name"
                            :label="$t('category.internal_name')"
                            :rules="rules.fieldRequired"
                            :counter="200"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <h5>
                          {{ $t("category.male_name") }}
                        </h5>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-tabs v-model="tab_name">
                            <v-tab
                              class="capitalize"
                              v-for="(item, index) in Object.keys(
                                editedItem.name
                              )"
                              :key="index"
                            >
                              {{ $t("form." + item) }}
                            </v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="tab_name">
                            <v-tab-item
                              v-for="(item, index) in Object.keys(
                                editedItem.name
                              )"
                              :key="index"
                            >
                              <v-text-field
                                :key="item"
                                v-model="editedItem.name[item]"
                                :counter="200"
                                :label="$t('category.male_name')"
                              />
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-row>
                      <v-row>
                        <h5>
                          {{ $t("category.female_name") }}
                        </h5>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-tabs v-model="tab_female_name">
                            <v-tab
                              class="capitalize"
                              v-for="(item, index) in Object.keys(
                                editedItem.female_name
                              )"
                              :key="index"
                            >
                              {{ $t("form." + item) }}
                            </v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="tab_female_name">
                            <v-tab-item
                              v-for="(item, index) in Object.keys(
                                editedItem.female_name
                              )"
                              :key="index"
                            >
                              <v-text-field
                                :key="item"
                                v-model="editedItem.female_name[item]"
                                :counter="200"
                                :label="$t('category.female_name')"
                              />
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">{{ $t("button.cancel") }}</v-btn>
                  <v-btn color="primary" @click="save">{{
                    $t("button.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="primary" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
export default {
  mixins: [validationRules],
  data() {
    return {
      dialog: false,
      search: "",
      categories: [],
      editedIndex: -1,
      tab_name: 0,
      tab_female_name: 0,
      editedItem: {
        internal_name: "",
        name: {
          es: "",
          en: "",
          gl: ""
        },
        female_name: {
          es: "",
          en: "",
          gl: ""
        }
      },
      defaultItem: {
        internal_name: "",
        name: {
          es: "",
          en: "",
          gl: ""
        },
        female_name: {
          es: "",
          en: "",
          gl: ""
        }
      }
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("title.newItem")
        : this.$t("title.editItem");
    },
    headers() {
      return [
        {
          text: this.$t("category.internal_name"),
          value: "internal_name"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/category";
      axios
        .get(path)
        .then(response => {
          this.categories = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.id = item.id;
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/category/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.categories.indexOf(item);
            this.categories.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        const index = this.editedIndex;
        const data = this.editedItem;
        if (index > -1) {
          path = this.$store.state.endpoint + "/category/" + this.editedItem.id;
          axios
            .patch(path, this.editedItem)
            .then(response => {
              Object.assign(this.categories[index], data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/category";
          const data = this.editedItem;
          axios
            .post(path, data)
            .then(response => {
              data.id = response.data.id;
              this.categories.push(data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
        this.close();
      }
    }
  }
};
</script>
